// extracted by mini-css-extract-plugin
export default {"sectionTitle":"cK_dB","container":"cK_d","imageWrapper":"cK_gv","image":"cK_dy","title":"cK_c0","arrowWrapper":"cK_kP","arrowIcon":"cK_gP"};